var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"alert alert-danger d-flex justify-content-center"},[_vm._v("\nدسترسی به صفحه مورد نظر برای شما امکان پذیر نمی باشد.\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }